import i18n from '@/i18n/config';
// BookingGrid shared helpers and constants

export const STATUS_COLORS: Record<string, string> = {
  draft: 'bg-secondary text-secondary-foreground',
  pending: 'bg-[rgba(245,158,11,0.15)] text-[#D97706] dark:text-[#FBBF24] border border-[rgba(245,158,11,0.2)]',
  confirmed: 'bg-[rgba(16,185,129,0.15)] text-[#0E9F6E] dark:text-[#34D399] border border-[rgba(16,185,129,0.2)]',
  cancelled: 'bg-[rgba(239,68,68,0.15)] text-[#D92D20] dark:text-[#F87171] border border-[rgba(239,68,68,0.2)]',
  completed: 'bg-[rgba(0,102,255,0.12)] text-[#0052CC] dark:text-[#4D94FF] border border-[rgba(0,102,255,0.2)]',
  invoiced: 'bg-[rgba(139,92,246,0.15)] text-[#7C3AED] dark:text-[#A78BFA] border border-[rgba(139,92,246,0.2)]',
  // Iter 517al #14: Betinget taxi — orange/amber like `pending` but with a
  // distinct hue so operators can spot it at a glance.
  betinget_taxi: 'bg-[rgba(251,146,60,0.18)] text-[#C2410C] dark:text-[#FDBA74] border border-[rgba(251,146,60,0.3)]',
};

const TYPE_LABELS_NO: Record<string, string> = {
  P: 'Per-passasjer (delt med stor gruppe)', T: 'Taxi', ST: 'Delt taxi', MB: 'Minibuss', SMB: 'Delt minibuss', B: 'Buss', SB: 'Delt buss',
};
export const typeLabel = (code: string) => i18n.t(`typeCode.${code}`, TYPE_LABELS_NO[code] || code);

export function getTypeCode(booking: any) {
  const pax = booking?.number_of_passengers || 0;
  // Default-koder (uten tur-kontekst). Backend setter den korrekte koden via
  // `reclassify_trip_bookings` når en tur tildeles. Frontend respekterer den
  // lagrede verdien primært, og falle tilbake til pax-baserte regler.

  // 1) Hvis backend har eksplisitt satt en kort kode, bruk den.
  const stored = (booking?.vehicle_type_code || booking?.vehicle_type || '').toString().trim();
  if (stored && ['P','T','ST','MB','SMB','B','SB'].includes(stored)) {
    return { code: stored, label: typeLabel(stored) };
  }

  // 2) Per-passasjer-flagg overstyrer alltid
  if (booking?.is_per_passenger_pricing) {
    return { code: 'P', label: typeLabel('P') };
  }

  // 3) Pax-basert default + Delt-flagg
  const shared = booking?.is_shared_transport || booking?.shared_trip || false;
  if (pax > 15) return { code: shared ? 'SB' : 'B', label: typeLabel(shared ? 'SB' : 'B') };
  if (pax >= 9) return { code: shared ? 'SMB' : 'MB', label: typeLabel(shared ? 'SMB' : 'MB') };
  if (pax >= 1) return { code: shared ? 'ST' : 'T', label: typeLabel(shared ? 'ST' : 'T') };
  return { code: 'T', label: i18n.t('typeCode.empty', 'Tom booking') };
}

export const BATCH_EDIT_FIELDS = [
  { value: 'status', label: 'Status' },
  { value: 'from_location', label: 'From' },
  { value: 'to_location', label: 'To' },
  { value: 'departure_time', label: 'Time' },
  { value: 'driver_external', label: 'Driver' },
  { value: 'vehicle', label: 'Vehicle' },
];
